// Modules
import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { FormCard } from 'components/content-containers/cards';
import { Page, PageContent, PageHeader } from 'components/page';
import SVG from 'components/widgets/icons/svg';
import Watch from 'services/data/watch';
import WatchForm from 'components/models/company/watch-form';
import appHistory from 'app-history';

import * as actions from '../store/actions';


export default function WatchAdd({ id }) {
  const { data: company } = actions.useCompany(id, { enable: !!id });
  const { refetch } = actions.useCompanyWatches(id, { enable: !!id });

  const onSubmit = values => {
    const create = _.clone(values);

    return Watch.create(create)
      .then(() => { if (company) return refetch(); })
      .then(() => {
        if (company) return appHistory.push(`/companies/${company.id}/watches`);
        return appHistory.push('/admin/watches');
      });
  };

  const initialValues = { date: moment().toDate() };

  if (company) initialValues.company = company.id;

  const watchForm = (
    <PageContent className="watches bg-medium-blue-grey">
      <div className="form-summary flex flex-equal-children">
        <FormCard className="form-form">
          <div className="form-header">
            <SVG src="svg/growth.svg" className="growth" />
            <h5 className="form-title">Add Watch</h5>
          </div>
          <WatchForm
            initialValues={initialValues}
            onSubmit={onSubmit}
          />
        </FormCard>
      </div>
    </PageContent>
  );

  if (company) return watchForm;

  return (
    <Page>
      <PageHeader title="Add Watch" />
      {watchForm}
    </Page>
  );
}
